import React, { useState } from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { generateImageId } from '../redux/imageDbSlice';
import useCurrentUserId from '../hooks/useCurrentUserId';
import useLatelyImages from '../hooks/useLatelyImages';
import { FullSizeImageAddType, updateImageDbs } from '../general';
import { initial } from '../card_components/index';
import DrawToolContent, { DrawSettingType, ActionsHashType, UndoneActionType, DrawTextHashType } from './DrawToolContent';

type DrawToolDialogProps = {
  open: boolean;
  onClose: () => void;
  onSave: (image: FullSizeImageAddType) => void;
}
const DrawToolDialog: React.FC<DrawToolDialogProps> = ({open, onClose, onSave}) => {
  const dispatch = useDispatch();
  const userId = useCurrentUserId();
  const [setting, setSetting] = useState<DrawSettingType>(initial.drawSetting);
  const [actionIds, setActionIds] = useState<string[]>([]);
  const [actions, setActions] = useState<ActionsHashType>({});
  const [undoneActions, setUndoneActions] = useState<UndoneActionType[]>([]);
  const [textHash, setTextHash] = useState<DrawTextHashType>({});
  const [latelyIds, , latelyImagesId] = useLatelyImages();

  const initState = () => {
    setSetting(initial.drawSetting);
    setActionIds([]);
    setActions({});
    setUndoneActions([]);
    setTextHash({});
  }
  const saveData = () => {
    const svg = document.getElementById('svg');
    if (!svg) return;
    const svgData = new XMLSerializer().serializeToString(svg);
    let hex = setting.backgroundColor;
    if (hex.slice(0, 1) === "#") hex = hex.slice(1);
    if (hex.length === 3) hex = hex.slice(0, 1) + hex.slice(0, 1) + hex.slice(1, 2) + hex.slice(1, 2) + hex.slice(2, 3) + hex.slice(2, 3);
    const rgb = [hex.slice(0, 2), hex.slice(2, 4), hex.slice(4, 6)].map((str) => {
      return parseInt(str, 16);
    });

    const canvas = document.createElement('canvas');
    canvas.setAttribute('width', '9600');// 9600
    canvas.setAttribute('height', '9600');// 9600
    let context = canvas.getContext('2d');
    let image = new Image();
    image.onload = function(){
      if (!context) return;
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      let imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      for(let i = 0; i < (imageData.width * imageData.height); i++) {
        if((imageData.data[i * 4] === rgb[0]) &&
          (imageData.data[i * 4 + 1] === rgb[1]) &&
          (imageData.data[i * 4 + 2] === rgb[2])) {
          imageData.data[i * 4 + 3] = 0;
        }
      }
      context.putImageData(imageData, 0, 0);
      const dataUrlBase64 = canvas.toDataURL('image/png');
      compressedImage.src = dataUrlBase64;
      // const imageId = generateImageId();
      // dispatch(addImage({id: imageId, userId: userId || 'no user', dataUrl: dataUrlBase64}));
      // onSave(imageId);
      // onClose();
    }

    const compressionCanvas = document.createElement('canvas');
    compressionCanvas.setAttribute('width', '480');
    compressionCanvas.setAttribute('height', '480');
    let compressionContext = compressionCanvas.getContext('2d');
    let compressedImage = new Image();
    compressedImage.onload = () => {
      if (!compressionContext) return;
      compressionContext.drawImage(compressedImage, 0, 0, compressionCanvas.width, compressionCanvas.height);
      const dataUrlBase64 = compressionCanvas.toDataURL('image/png');
      const imageId = generateImageId();
      updateImageDbs({ dispatch, imageId, dataUrlBase64, userId, latelyIds, latelyImagesId });

      onSave({ id: imageId, width: 480, height: 480});
      onClose();
    }

    image.src = 'data:image/svg+xml;charset=utf-8;base64,' + btoa(unescape(encodeURIComponent(svgData)));
  }

  return(
    <>
      <Dialog open={open} onClose={onClose} onExited={initState} maxWidth='md'>
        <DialogTitle>
          お絵かきエディタ
        </DialogTitle>
        <DialogContent style={{overflow: 'hidden'}}>
          <DrawToolContent kind="tool" shadow={true}
            setting={setting} setSetting={setSetting}
            actionIds={actionIds} setActionIds={setActionIds}
            actions={actions} setActions={setActions}
            undoneActions={undoneActions} setUndoneActions={setUndoneActions}
            textHash={textHash} setTextHash={setTextHash}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="text" color="primary" onClick={onClose}>
            キャンセル
          </Button>
          <Button variant="text" color="primary" onClick={saveData}>
            保存する
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DrawToolDialog;
